<div class="footer-container">
  <div style="text-align: center;width: 99.5%;background: inherit;background-color: rgba(255, 255, 255, 1);
box-sizing: border-box;padding-top: 5px;border-width: 1px;border-style: solid;border-color: rgba(121, 121, 121, 1);
border-radius: 0px;border-bottom-color:white">
    <button id="save" type="button" style="width:40%" (click)="onAddRecordToBatch()" [disabled]= "orderService.orderDto.disableAddReturnToBatchButton" class="uitk-c-button uitk-c-button--default uitk-u-margin-right--base uitk-u-margin-bottom--xs">
      Add Return to Batch
    </button>
  </div>
</div>
